import { getUserConfiguration } from 'owa-session-store';
import { getSupportedThemeIds, getCurrentThemeId } from 'owa-theme';
export default function isThemePreviewDirty() {
    // For whatever reason, when the user has the 'base' theme saved, the server returns it as an empty string
    var savedThemeId = getUserConfiguration().UserOptions.ThemeStorageId || 'base';
    var loadedThemeId = getCurrentThemeId();
    return (savedThemeId !== loadedThemeId &&
        // We check against available theme ids, so that the form is not immediately dirty
        // just because you have a theme not available through the form
        getSupportedThemeIds().indexOf(loadedThemeId) !== -1);
}
//# sourceMappingURL=isThemePreviewDirty.js.map